import WithValue from './WithValue';

export default WithValue;
